import React, {useEffect, useState} from 'react'
import {
  autoUpdate,
  flip, FloatingPortal,
  offset,
  shift,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react'
import {KTSVG} from '../../../../../_metronic/helpers'

const FavorisPopper = (props) => {
  const {
    setOpenFilter,
    setOpenFavoris,
    openFavoris,
    applyFilter = () => {},
    handleFavorisDelete = () => {},
    handleFavoriActivation = () => {},
    setFavoris = () => {},
    favoris,
    favorisLoader,
    favorisDeleteLoader,
    allowedToManageFavori,
    clientDemandeEquipe,
  } = props

  // --- Popper "Favoris" ---
  const {
    refs: favorisRefs,
    floatingStyles: favorisFloatingStyles,
    context: favorisContext,
  } = useFloating({
    open: openFavoris,
    onOpenChange: setOpenFavoris,
    placement: 'bottom-start',
    middleware: [offset(6), flip(), shift()],
    whileElementsMounted: (reference, floating, update) =>
      autoUpdate(reference, floating, update, {
        animationFrame: true,
      }),
  })

  const favorisDismiss = useDismiss(favorisContext, {
    outsidePressEvent: 'mousedown',
  })

  const {getReferenceProps: getFavorisReferenceProps, getFloatingProps: getFavorisFloatingProps} =
    useInteractions([favorisDismiss])

  // Switch affichage entre Favoris et Filtre
  const handleFavorisOpening = () => {
    setOpenFilter(false) // Ferme l'autre popper
    setOpenFavoris((prev) => !prev)
  }

  const applyFavoris = (favoris) => {
    const isAlreadyActive = favoris?.actif;

    if (isAlreadyActive) {
      // Désactivation
      handleFavoriActivation(favoris, false);

      setFavoris((prev) =>
        prev.map((item) => ({
          ...item,
          actif: false,
        }))
      );

    } else {
      // Sélectionner le favori
      handleFavoriActivation(favoris, true);

      setFavoris((prev) =>
        prev.map((item) => ({
          ...item,
          actif: item.id === favoris?.id,
        }))
      )
    }
  };

  const favorisEquipes = favoris?.filter((fav) => {
    const userEquipeIds = Array.isArray(clientDemandeEquipe)
      ? clientDemandeEquipe.map((e: any) => e?.value)
      : []

    return (
      fav?.filterData?.shareWithTeam?.length > 0 &&
      fav.filterData.shareWithTeam.some((equipeId: number) =>
        userEquipeIds.includes(equipeId)
      )
    )
  })

  const favorisPerso = favoris?.filter((fav) => {
    const shareWithTeam = fav?.filterData?.shareWithTeam

    return !shareWithTeam || shareWithTeam.length === 0
  })

  return (
    <>
      <button
        className={'btn btn-sm btn-light-warning flex-fill py-2'}
        ref={favorisRefs.setReference}
        {...getFavorisReferenceProps()}
        onClick={handleFavorisOpening}
      >
        <div className={'d-flex justify-content-between align-items-center'}>
          <i className='ki-outline ki-star fs-2'></i>
          <label className={'fs-6'}>Favoris</label>
          {favorisLoader ? (
            <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
          ) : (
            <i className={`fs-2 ki-outline ki-${openFavoris ? 'up' : 'down'}`}></i>
          )}
        </div>
      </button>
      {openFavoris && (
        <FloatingPortal>
          <div
            className='p-6 shadow bg-white p-2 rounded  w-300px'
            ref={favorisRefs.setFloating}
            style={{...favorisFloatingStyles, zIndex: '9999'}}
            {...getFavorisFloatingProps()}
          >
            <div className={'d-flex w-100 align-items-center'}>
              <div className={'fw-bold text-start fs-5 w-100'}>Listes de votre Favori</div>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                aria-label='Close'
                onClick={() => setOpenFavoris(false)}
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <hr className={'flex-grow-1 text-muted w-100'} />
            <div className={'d-flex gap-2 flex-column mh-300px overflow-y-scroll'}>
              <>
                <p className={'text-small fw-semibold mb-0'}>Favori de l'equipe</p>
                {favorisEquipes?.length > 0 ? (
                  favorisEquipes?.map((fav) => {
                    return (
                      <div className={''}>
                        <div className='form-check form-check-custom form-check-solid form-check-sm justify-content-between p-2 bg-hover-light-primary rounded-1'>
                          <div className={'d-flex'}>
                            <input
                              className='form-check-input me-2'
                              type='radio'
                              id={`option-${fav?.id}`}
                              name={'opt-fav'}
                              checked={!!fav?.actif}
                              onClick={() => applyFavoris(fav)}
                              onChange={() => {}}
                            />
                            <label className='form-check-label' htmlFor={`option-${fav?.id}`}>
                              {fav?.libelle}
                            </label>
                          </div>
                          {allowedToManageFavori &&
                            (favorisDeleteLoader[fav.id] ? (
                              <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
                            ) : (
                              <i
                                className='ki-duotone ki-trash fs-2 cursor-pointer text-danger'
                                onClick={() => handleFavorisDelete(fav?.id, fav?.actif)}
                              >
                                <span className='path1'></span>
                                <span className='path2'></span>
                                <span className='path3'></span>
                                <span className='path4'></span>
                                <span className='path5'></span>
                              </i>
                            ))}
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <p className={'text-muted text-center'}>(Aucun Favori créé)</p>
                )}
                <hr className={'flex-grow-1 text-muted w-100 my-1'} />
                <p className={'text-small fw-semibold mb-0'}>Favori personnalisé</p>
                {favorisPerso?.length > 0 ? (
                  favorisPerso.map((fav) => {
                    return (
                      <div className={''}>
                        <div className='form-check form-check-custom form-check-solid form-check-sm justify-content-between p-2 bg-hover-light-primary rounded-1'>
                          <div className={'d-flex'}>
                            <input
                              className='form-check-input me-2'
                              type='radio'
                              id={`option-${fav?.id}`}
                              name={'opt-fav'}
                              checked={!!fav?.actif}
                              onClick={() => applyFavoris(fav)}
                              onChange={() => {}}
                            />
                            <label className='form-check-label' htmlFor={`option-${fav?.id}`}>
                              {fav?.libelle}
                            </label>
                          </div>
                          {favorisDeleteLoader[fav.id] ? (
                            <span className='spinner-border spinner-border-sm align-middle w-13px h-13px'></span>
                          ) : (
                            <i
                              className='ki-duotone ki-trash fs-2 cursor-pointer text-danger'
                              onClick={() => handleFavorisDelete(fav?.id, fav?.actif)}
                            >
                              <span className='path1'></span>
                              <span className='path2'></span>
                              <span className='path3'></span>
                              <span className='path4'></span>
                              <span className='path5'></span>
                            </i>
                          )}
                        </div>
                      </div>
                    )
                  })
                ) : (
                  <p className='text-muted text-center'>(Aucun Favori créé)</p>
                )}
              </>
            </div>
            <hr className={'flex-grow-1 text-muted w-100'} />
            <div className={'text-end w-100'}>
              <button
                type='button'
                className='btn btn-sm btn-secondary'
                onClick={() => setOpenFavoris(false)}
              >
                Fermer
              </button>
            </div>
          </div>
        </FloatingPortal>
      )}
    </>
  )
}

export default FavorisPopper